export interface Supplier {
	Id: number | null;
	Name: string;
	ShortName: string;
	Number: string;
	Address1: string;
	Address2: string;
	Address3: string;
	Address4: string;
	City: string;
	State: string;
	Zip: string;
	Country: string;
	Phone: string;
	Fax: string;
	Contact: string;
	ContactName2: string;
	Active: boolean;
}

export const SUPPLIER_INITIAL_VALUES: Supplier = {
	Id: null,
	Name: "",
	ShortName: "",
	Number: "",
	Address1: "",
	Address2: "",
	Address3: "",
	Address4: "",
	City: "",
	State: "",
	Zip: "",
	Country: "",
	Phone: "",
	Fax: "",
	Contact: "",
	ContactName2: "",
	Active: true,
};
